

export const reviews = [
   {
      id: 1,
      name: 'Розалия',
      date: '02.24.21',
      comment: 'Ваша доставка и ваши блюда лучшие в Харькове!) всегда очень вкусно, вовремя, всегда вежливые курьеры и девушки на телефоне',
   },
   {
      id: 2,
      name: 'Eugeny',
      date: '02.24.21',
      comment: 'Ваша доставка и ваши блюда лучшие в Харькове!) всегда очень вкусно, вовремя, всегда вежливые курьеры и девушки на телефоне',
   },
   {
      id: 3,
      name: 'Oleg',
      date: '02.24.21',
      comment: 'Ваша доставка и ваши блюда лучшие в Харькове!) всегда очень вкусно, вовремя, всегда вежливые курьеры и девушки на телефоне',
   },
   {
      id: 4,
      name: 'Milana',
      date: '02.24.21',
      comment: 'Ваша доставка и ваши блюда лучшие в Харькове!) всегда очень вкусно, вовремя, всегда вежливые курьеры и девушки на телефоне',
   },
   {
      id: 5,
      name: 'Розалия',
      date: '02.24.21',
      comment: 'Ваша доставка и ваши блюда лучшие в Харькове!) всегда очень вкусно, вовремя, всегда вежливые курьеры и девушки на телефоне',
   },
   {
      id: 6,
      name: 'Розалия',
      date: '02.24.21',
      comment: 'Ваша доставка и ваши блюда лучшие в Харькове!) всегда очень вкусно, вовремя, всегда вежливые курьеры и девушки на телефоне',
   },
]